import React from 'react';
import PropTypes from 'prop-types';

import styles from '../subscribe-today.module.scss';
import { Plans } from '../../constants';
import Banner from '../Banner';
import PlanList from '../PlanList';

const DesktopLayout = ({ selectedPlan, handlePlanChange, hostMemberName }) => {
  const subtitle = hostMemberName.length !== 0
    ? `Keep accessing amazing sales by becoming a FabFitFun member, ${hostMemberName}.`
    : 'Keep accessing amazing sales by becoming a FabFitFun member.';
  return (
    <div className={styles['desktop-layout']}>
      <Banner
        title="Love FabFitFun?"
        subtitle={subtitle}
      />
      <section className={styles.plans}>
        <PlanList selectedPlan={selectedPlan} handlePlanChange={handlePlanChange} />
      </section>
      <div className={styles['desktop-placeholder']} />
    </div>
  );
};

DesktopLayout.defaultProps = {
  selectedPlan: Plans.ANNUAL,
  handlePlanChange: () => { },
  hostMemberName: '',
};

DesktopLayout.propTypes = {
  selectedPlan: PropTypes.string,
  handlePlanChange: PropTypes.func,
  hostMemberName: PropTypes.string,
};

export default DesktopLayout;
